export default "__VITE_ASSET__BhmzhoR9__"